import { OrString } from 'types';
import { elementClick } from 'utils/html';

export const OVERLAY_BG_IDS = {
  drawer: '__drawer_overlay__',
  modal: '__modal_overlay__',
  sideSheet: '__sideSheet_overlay__',
  popOver: '__popOver_overlay__',
};

type OverlayTarget = OrString<keyof typeof OVERLAY_BG_IDS>;

/**
 * This is an helper to escape any overlay the user has currently on,
 * without worrying about managing the open/close state
 *
 * Useful for use-cases in which the overlay is dismissible without any
 * required action
 */
export function overlayEscape(target?: OverlayTarget) {
  const id =
    OVERLAY_BG_IDS[target as keyof typeof OVERLAY_BG_IDS] ||
    (typeof target === 'string' ? target : '');

  elementClick(id || undefined);
}
